import { SwitchHorizontalIcon } from '@heroicons/react/outline';

export function VerticalSplitDivider() {
  return (
    <div className="flex h-full w-8 flex-col items-center justify-center py-2">
      <div className="border-info-200 w-0 flex-1 border-l" />
      <SwitchHorizontalIcon className="text-info-400 my-3 h-4 w-4" />
      <div className="border-info-200 w-0 flex-1 border-l" />
    </div>
  );
}
